<template>
  <section class="why-section">
    <div class="wrapper">
      <div class="why-section-content">
        <h2 class="why-section-title title weight-900 big">
          {{ $t("Why Choose Us?") }}
        </h2>
        <p class="why-section-description desc desc-20 weight-500">
          {{
            $t(
              "We’re a team of Minecraft enthusiasts who have been crafting private worlds for many years."
            )
          }}
        </p>
        <div class="why-section-cards">
          <div class="why-card">
            <img
              src="@/assets/why-us-1.webp"
              alt="Why buy island 1"
              class="why-card-image"
            />
            <div class="desc desc-20">
              <b>{{ $t("Reliable Infrastructure ") }}</b>
            </div>
            <p class="desc desc-20 weight-500 why-card-text">
              {{ $t("Tier III data centers in Europe and North America.") }}
            </p>
          </div>

          <div class="why-card">
            <img
              src="@/assets/why-us-2.webp"
              alt="Why buy island 2"
              class="why-card-image"
            />
            <div class="desc desc-20">
              <b>{{ $t("Instant Activation") }}</b>
            </div>
            <p class="desc desc-20 weight-500 why-card-text">
              {{ $t("Your island is ready within five minutes of payment.") }}
            </p>
          </div>

          <div class="why-card">
            <img
              src="@/assets/why-us-3.webp"
              alt="Why buy island 3"
              class="why-card-image"
            />
            <div class="desc desc-20">
              <b>{{ $t("Transparent Support") }}</b>
            </div>
            <p class="desc desc-20 weight-500 why-card-text">
              {{
                $t(
                  "24/7 live chat and a vibrant Discord community for quick solutions."
                )
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { MODALS } from "../store/modules/modals";

export default {
  name: "WhySection",
  props: {
    isAuth: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {
    handleClick() {
      if (this.isAuth) {
        this.$router.push({ path: "/profile/buy-island" });
      } else {
        this.$store.dispatch("modals/openModal", {
          modalName: MODALS.SIGNUP,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Using descriptive class names without nesting for better DevTools visibility
.why-section {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 84px 16px 110px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #113a54b2;
    backdrop-filter: blur(10px);
  }

  @media (max-width: 1600px) {
    padding: 116px 80px 99px;
  }

  @media (max-width: 1024px) {
    padding: 80px 40px;
  }

  @media (max-width: 768px) {
    padding: 60px 20px;
  }

  &-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin: 76px auto 0;
    position: relative;
  }
}
.why-card {
  display: flex;
  flex-direction: column;
  align-items: center;

  &-image {
    width: 100px;
    margin-bottom: 50px;
  }

  &-text.desc {
    text-align: center;
    margin-top: 32px;
    line-height: 150%;
  }
}

@media (max-width: 1200px) {
  .why-section-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .why-section-cards {
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
  }
  .why-card-image {
    margin-bottom: 0;
  }
}

.why-section-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

.title.why-section-title {
  line-height: 150%;
  @media (max-width: 768px) {
    font-size: 40px;
    line-height: 1.2;
    margin-bottom: 40px;
  }
}

.desc.why-section-description {
  position: relative;
  max-width: 885px;
  line-height: 150%;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.4;
  }
}

.button.secondary {
  max-width: 289px;
}
</style>
